import React, { useEffect, useState } from 'react';
import { getAppData } from '../../../utils/acquisition-utils';

interface IBalanceTransfersFormProps {
    receiveTransferLabel?: string;
}

export const BalanceTransfersForm = (props: IBalanceTransfersFormProps): JSX.Element => {
    const [isBalanceTransferSelected, setIsBalanceTransferSelected] = useState<boolean>();

    useEffect(() => {
        const setInfo = async () => {
            setIsBalanceTransferSelected(!!(await getAppData()).IsBalanceTransferSelected);
        };
        setInfo();
    }, []);
    return (
        <div className='PersonalInformation__infoContainer'>
            <p>
                <b>{props.receiveTransferLabel}:</b>
            </p>
            <p>
                {isBalanceTransferSelected ? 'Yes' : 'No'}
            </p>
        </div>
    );
};
